import React from 'react';
import styles from './LoadingBar.module.scss';

export default function () {
    return <div className={styles.bar}>{}</div>;
}
